exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".link-text-area {\n  border: none; \n  border-bottom: 1px solid #9e9e9e;\n  padding: 5px;\n  min-height: 64px;\n  margin-left: 0px;\n  margin-right: 0px;\n  margin-top: 6px;\n  margin-bottom: 20px;\n  cursor: text;\n  transition: all 0.1s;\n}\n\n.link-text-area div[contenteditable] {\n  outline: none;\n  word-wrap: break-word;\n  white-space: pre-wrap;\n  margin-left: -5px;\n  min-height: 64px;\n  \n}\n\n.link-text-area-label {\n  color: #f9a825;\n}\n\n.link-text-area-selected {\n  border-bottom: 2px solid #f9a825;\n}\n\n.link-text-area-label-no-active {\n  transform: none !important;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/app/shared/helper-components/link-text-area.component.css
// module id = 470
// module chunks = 1